// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/InventoryManagement/inventory.css
// module id = 384
// module chunks = 0